export default __webpack_public_path__ + "static/article-sustainable-eco-friendly-home-renovations-ac5bd5be3e77384f392cdc3e6e9672ab.jpg";